<template>
  <div class="auction-detail-page">
    <!-- 页面标题 -->
    <section class="page-banner assets-banner">
      <!-- 数量为1时，显示单张图片 -->
      <div v-if="bannerSlides.length === 1" class="banner-single-bg">
        <img :src="bannerSlides[0].carouselUrl" class="bg-img">
      </div>

      <!-- 数量大于1时，显示轮播幻灯片 -->
      <div v-else-if="bannerSlides.length > 1" class="banner-slider-bg">
        <div v-for="(slide, idx) in bannerSlides" :key="idx" class="bg-slide" :class="{ active: currentBanner === idx }">
          <img :src="slide.carouselUrl" class="bg-img">
        </div>
      </div>

      <div class="container">
        <h1>在拍资产详情</h1>
        <el-breadcrumb separator="/" class="breadcrumb">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item :to="{ path: '/assets' }">资产专区</el-breadcrumb-item>
          <el-breadcrumb-item>在拍资产详情</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
    </section>

    <!-- 资产详情内容 -->
    <section class="asset-detail-section" v-if="assetDetail">
        <div class="container detail-container">
            <div class="asset-detail-layout">
                <!-- 左侧主要内容 -->
                <div class="asset-detail-main">
                    <!-- 资产图片轮播 -->
                    <div class="asset-gallery" v-if="imageList && imageList.length > 0">
                        <div class="gallery-main">
                            <div class="main-image-slider">
                                <div class="slide-item active" data-type="image">
                                    <el-image 
                                        class="preview-image"
                                        :src="imageList[currentImageIndex]" 
                                        :preview-src-list="getPreviewList()"
                                        fit="contain"
                                    >
                                    </el-image>
                                </div>
                            </div>
                            <button class="gallery-prev" @click="prevImage" v-if="imageList.length > 1"><i class="el-icon-arrow-left"></i></button>
                            <button class="gallery-next" @click="nextImage" v-if="imageList.length > 1"><i class="el-icon-arrow-right"></i></button>
                            <div class="gallery-counter"><span class="current">{{ currentImageIndex + 1 }}</span> / <span class="total">{{ imageList.length }}</span></div>
                        </div>
                        <div class="gallery-thumbs" v-if="imageList.length > 1">
                            <div class="thumb-item" v-for="(img, idx) in imageList" :key="idx" 
                                 :class="{active: currentImageIndex === idx}" 
                                 @click="currentImageIndex = idx">
                                <img :src="img" alt="缩略图">
                            </div>
                        </div>
                    </div>

                    <!-- 资产标题 -->
                    <div class="asset-header">
                        <h1 class="asset-title">{{ assetDetail.assetName }}</h1>
                        <div class="asset-location">
                            <!-- <i class="el-icon-location-information"></i> -->
                            <!-- <span>{{ assetDetail.address || (assetDetail.provinceName + assetDetail.cityName + assetDetail.districtName) || '地址详见详情' }}</span> -->


                            <span class="view-count" v-if="$store.state.siteConfig.showVisits === '1'"><i class="el-icon-view"></i> {{ assetDetail.visits }}</span>
                        </div>
                      <div class="tags">
                        <el-tag size="mini" v-for="value in assetDetail.tagsList" :key="value" style="margin-right: 10px;">{{ value }}</el-tag>
                      </div>
                    </div>

                    <!-- 标签切换 -->
                    <div class="detail-tabs">
                        <button class="tab-btn" :class="{active: currentTab === 'info'}" @click="currentTab = 'info'">资产情况</button>
                        <button v-if="pcMianze" class="tab-btn" :class="{active: currentTab === 'disclaimer'}" @click="currentTab = 'disclaimer'">免责声明</button>
                    </div>

                    <!-- 资产情况 -->
                    <div class="tab-content" :class="{active: currentTab === 'info'}" id="info">
                        <div class="info-section">
                            <div class="info-row" v-if="assetDetail.assetValue">
                                <span class="info-label">起拍价：</span>
                                <span class="info-value price">￥{{ assetDetail.assetValue }}万元</span>
                              <span class="info-label">资产类别：</span>
                              <span class="info-value">{{ assetDetail.categoryName }}</span>
                            </div>
                            <div class="info-row" v-else>
                                <span class="info-label">起拍价：</span>
                                <span class="info-value price">面议</span>
                              <span class="info-label">资产类别：</span>
                              <span class="info-value">{{ assetDetail.categoryName }}</span>
                            </div>
                          <div class="info-row">
                            <span class="info-label">拍卖组织方：</span>
                            <span class="info-value">{{ assetDetail.assetType == '1' ? "辽宁资产有限责任公司" : "外部资产" }}</span>
                            <span class="info-label">拍卖渠道：</span>
                            <span class="info-value">{{ assetDetail.auctionChannelName }}</span>
                          </div>
                            <div class="info-row" v-if="formatDateTime(assetDetail.auctionStartTime)">
                                <span class="info-label">拍卖开始时间：</span>
                                <span class="info-value">{{ formatDateTime(assetDetail.auctionStartTime) }}</span>
                                <span class="info-label">拍卖结束时间：</span>
                                <span class="info-value">{{ formatDateTime(assetDetail.auctionEndTime) }}</span>
                            </div>
                          <div class="info-row">
                            <span class="info-label">拍卖状态：</span>
<!--                            <span class="info-value">{{ getStatusLabel(assetDetail.status) }}</span>
                            <span class="info-label">拍卖结果：</span>-->
                            <span class="info-value">{{assetDetail.auctionStatus}}</span>
                          </div>

                            <!-- <div class="info-row" v-if="assetDetail.updateTime">
                                <span class="info-label">更新时间：</span>
                                <span class="info-value">{{ parseDateString(assetDetail.updateTime) }}</span>
                            </div> -->
                             <div class="info-row">
                                <span class="info-label" v-if="assetDetail.provinceName">省份：</span>
                                <span class="info-value" v-if="assetDetail.provinceName">{{ assetDetail.provinceName }}</span>
                                 <span class="info-label" v-if="assetDetail.cityName">城市：</span>
                                <span class="info-value" v-if="assetDetail.cityName">{{ assetDetail.cityName}}</span>
                            </div>
                              <div class="info-row">
                                <span class="info-label">详细地址：</span>
                                <span>{{ assetDetail.address || (assetDetail.provinceName + assetDetail.cityName + assetDetail.districtName) }}</span>
                            </div>
                             <div class="info-row" v-if="assetDetail.auctionUrl">
                                <span class="info-label">竞拍直达：</span>
                                <span class="info-value"><a :href="assetDetail.auctionUrl" target="_blank" class="buy-link">前往竞拍页面</a></span>
                            </div>
                        </div>
                        <div class="info-section" v-if="assetDetail.assetDetail">
                            <h3>资产介绍：</h3>
                            <div class="advantage-content">
                                <div v-html="assetDetail.assetDetail"></div>
                            </div>
                        </div>

                      <div class="info-section" v-if="assetDetail.assetDetail || assetDetail.highlightDesc">
                        <h3>资产特质：</h3>
                        <div class="advantage-content">
                          <div class="advantage-zcys" v-if="assetDetail.highlightDesc">{{ assetDetail.highlightDesc }}</div>
                        </div>
                      </div>

                      <div class="info-section" v-if="assetDetail.attachmentList && assetDetail.attachmentList.length > 0">
                        <h3>附件下载：</h3>
                        <div class="advantage-content">
                            <div class="attachment-list">
                                <div class="attachment-item" v-for="(file, index) in assetDetail.attachmentList" :key="index">
                                    <div class="file-info" @click="handleFileClick(file)">
                                        <i :class="getFileIcon(file)"></i>
                                        <span class="file-name" :title="getFileName(file)">{{ getFileName(file) }}</span>
                                    </div>
                                    <el-button type="primary" size="small" icon="el-icon-download" plain @click="downloadFile(file)">
                                        下载
                                    </el-button>
                                </div>
                            </div>
                        </div>
                      </div>

                      <div class="info-section" v-if="assetDetail.assetDetail || assetDetail.highlightDesc">
                        <h3>资产备注：</h3>
                        <div class="advantage-content">
                          <div v-if="assetDetail.remark">{{ assetDetail.remark }}</div>
                        </div>
                      </div>
                      
                        <div class="info-section" v-if="$store.state.siteConfig.showMap === '1'">
                            <h3>地图：</h3>
                            <div class="map-view">
                                <BaiduMap
                                    v-if="!mapError && assetDetail && (assetDetail.address || assetDetail.provinceName)"
                                    :address="assetDetail.address || (assetDetail.provinceName + assetDetail.cityName + assetDetail.districtName)"
                                    title="资产位置"
                                    height="350px"
                                    @error="mapError = true"
                                />
                                <div v-else-if="assetDetail && assetDetail.addressImg" class="map-fallback">
                                    <img :src="assetDetail.addressImg" style="width: 100%; height: 350px; object-fit: cover; border-radius: 8px;">
                                </div>
                            </div>
                        </div>
                        <!-- 暂不支持单独嵌入高德地图URL因为资产数据未含经纬度参数，可依赖后端后期补充 -->
                    </div>

                    <!-- 免责声明 -->
                    <div class="tab-content" v-if="pcMianze" :class="{active: currentTab === 'disclaimer'}" id="disclaimer">
                        <div v-html="pcMianze.value">
                            
                        </div>
                    </div>

                    <!-- 上一篇下一篇导航 -->
                    <div class="article-nav">
                        <div class="prev-article">
                            <router-link v-if="prevAsset" :to="{ path: '/auction/detail', query: { id: prevAsset.assetId, keyword: keyword, categoryId: categoryId, assetType: assetType, sort: sort, from: from } }" style="text-decoration: none;">
                                <span class="nav-label"><i class="el-icon-arrow-left"></i> 上一篇</span>
                            </router-link>
                            <router-link v-if="prevAsset" :to="{ path: '/auction/detail', query: { id: prevAsset.assetId, keyword: keyword, categoryId: categoryId, assetType: assetType, sort: sort, from: from } }" class="nav-title">
                                {{ prevAsset.assetName }}
                            </router-link>
                        </div>
                        <div class="next-article">
                            <router-link v-if="nextAsset" :to="{ path: '/auction/detail', query: { id: nextAsset.assetId, keyword: keyword, categoryId: categoryId, assetType: assetType, sort: sort, from: from } }"  style="text-decoration: none;">
                                <span class="nav-label">下一篇 <i class="el-icon-arrow-right"></i></span>
                            </router-link>
                            <router-link v-if="nextAsset" :to="{ path: '/auction/detail', query: { id: nextAsset.assetId, keyword: keyword, categoryId: categoryId, assetType: assetType, sort: sort, from: from } }" class="nav-title">
                                {{ nextAsset.assetName }}
                            </router-link>
                        </div>
                    </div>
                </div>

                <!-- 右侧联系信息 -->
                <aside class="asset-detail-sidebar">
                    <div class="contact-card">
                        <div class="contact-person">
                            <div class="contact-avatar-wrap">
                                <img v-if="assetDetail.contactPhoto" :src="assetDetail.contactPhoto" alt="联系人" class="contact-avatar">
                                <div v-else class="contact-avatar-text">{{ getFirstChar(assetDetail.contactPerson || '拍') }}</div>
                            </div>
                            <div class="contact-name">{{assetDetail.contactPersonAbbr ||  assetDetail.contactPerson || '拍卖咨询' }}</div>
                        </div>
                        <div class="contact-divider"></div>
                        <div class="contact-item">
                            <i class="el-icon-phone-outline"></i>
                            <span>{{ assetDetail.contactPhone }}</span>
                        </div>
                        <div class="contact-item" v-if="assetDetail.contactEmail">
                            <i class="el-icon-message"></i>
                            <span>{{ assetDetail.contactEmail }}</span>
                        </div>
                        <div class="contact-item" v-if="assetDetail.contactAddress">
                            <i class="el-icon-location-outline"></i>
                            <span>{{ assetDetail.contactAddress }}</span>
                        </div>

                    </div>
                </aside>
            </div>
        </div>
    </section>
    <div v-else class="container detail-container" style="margin-top: 40px;">
      <div class="empty-state">
        <el-skeleton :rows="10" animated />
      </div>
    </div>

  </div>
</template>

<script>
import { getBannerList, getAuctionDetail, getLabelList, getPrevNextSolrAuction  } from '@/api/menu'
import BaiduMap from '@/components/BaiduMap.vue'

export default {
  name: 'AuctionDetail',
  components: { BaiduMap },
  data() {
    const routeSort = this.$route.query.sort || '';
    return {
      bannerSlides: [],
      currentBanner: 0,
      bannerTimer: null,
      assetDetail: null,
      assetId: this.$route.query.id,
      keyword: this.$route.query.keyword || '',
      categoryId: this.$route.query.categoryId || '',
      assetType: this.$route.query.assetType || '',
      sign: this.$route.query.sign || '',
      sort: routeSort === 'default' ? '' : routeSort,
      from: this.$route.query.from || '',
      imageList: [],
      currentImageIndex: 0,
      currentTab: 'info',
      pcMianze: null,
      mapError: false,
      prevAsset: null,
      nextAsset: null
    }
  },
  watch: {
    '$route.query.id': {
      handler(newId) {
        if (newId) {
          this.assetId = newId;
          this.keyword = this.$route.query.keyword || '';
          this.categoryId = this.$route.query.categoryId || '';
          this.assetType = this.$route.query.assetType || '';
          const routeSort = this.$route.query.sort || '';
          this.sort = routeSort === 'default' ? '' : routeSort;
          this.from = this.$route.query.from || '';
          this.fetchAuctionDetail();
          window.scrollTo({ top: 0, behavior: 'smooth' });
        }
      },
      immediate: false
    }
  },
  created() {
    this.fetchBanner("zczq");
    this.fetchLabel("pcMianze");
    if(this.assetId) {
      this.fetchAuctionDetail();
    }
  },
  mounted() {
    this.startBannerTimer();
  },
  beforeDestroy() {
    if (this.bannerTimer) {
      clearInterval(this.bannerTimer);
    }
  },
  methods: {
    async fetchLabel(name) {
      try {
        const res = await getLabelList({ name })
        if (res.code === 0) {
          this.pcMianze = res.data
        } 
      } catch (error) {
        console.error('获取免责声明失败', error)
      }
    },
    startBannerTimer() {
      this.bannerTimer = setInterval(() => {
        if (this.bannerSlides.length > 1) {
          this.currentBanner = (this.currentBanner + 1) % this.bannerSlides.length;
        }
      }, 4000);
    },
    async fetchBanner(groupCode) {
      try {
        const res = await getBannerList({ groupCode })
        if (res.code === 0) {
          this.bannerSlides = res.rows || []
        } 
      } catch (error) {
        console.error('获取轮播图失败', error)
      }
    },
    async fetchAuctionDetail() {
      try {
        const res = await getAuctionDetail(this.assetId, this.sign)
        if (res.code === 0 || res.code === 200) {
          this.assetDetail = res.data;
          this.processImages();
          if (this.sign != '1') {
            // 获取前后资产信息
            this.fetchPrevNext(this.assetDetail.infoType)
          }

          // 设置页面标题
          this.setPageTitle(res.data.assetName + '-在拍资产详情' || '在拍资产详情')
        }
      } catch (error) {
        console.error('获取在拍资产详情失败', error)
      }
    },
    setPageTitle(detailTitle) {
      const siteTitle = this.$store.state.siteConfig.showTitle || '辽宁资产管理有限公司'
      document.title = `${detailTitle} - ${siteTitle}`
    },
    processImages() {
      const list = [];
      // if (this.assetDetail.coverImage) {
      //   list.push(this.assetDetail.coverImage);
      // }
      if (this.assetDetail.images) {
        // split by comma if there are multiple images
        const imgs = this.assetDetail.images.split(',').filter(i => i.trim());
        imgs.forEach(img => {
          if (!list.includes(img.trim())) {
            list.push(img.trim());
          }
        });
      }
      this.imageList = list;
    },
    prevImage() {
      if (this.imageList.length > 0) {
        this.currentImageIndex = this.currentImageIndex > 0 ? this.currentImageIndex - 1 : this.imageList.length - 1;
      }
    },
    nextImage() {
      if (this.imageList.length > 0) {
        this.currentImageIndex = this.currentImageIndex < this.imageList.length - 1 ? this.currentImageIndex + 1 : 0;
      }
    },
    getOriginalImage(url) {
      if (!url) return '';
      if (url.indexOf("http") === 0) {
        return url;
      }
      return url.replace('_1024x768', '').replace(/\.jpg$/, '');
    },
    getPreviewList() {
      if (!this.imageList || this.imageList.length === 0) return [];
      const originalList = this.imageList.map(url => this.getOriginalImage(url));
      return [
        ...originalList.slice(this.currentImageIndex),
        ...originalList.slice(0, this.currentImageIndex)
      ];
    },
    getStatusLabel(status) {
      const statusMap = {
        '0': '未开始',
        '1': '进行中',
        '2': '已结束',
        '3': '已撤销'
      };
      return statusMap[status] || status || '未知状态';
    },
    parseDateString(val) {
      return val ? val.split(' ')[0] : '';
    },
    formatDateTime(val) {
      if (!val || val === 'null' || val === 'undefined') return '';
      const strVal = String(val).trim();
      if (strVal === '') return '';

      // Match YYYY-MM-DD HH:mm:ss or YYYY-MM-DDTHH:mm:ss
      const match = strVal.match(/^(\d{4})[-/](\d{2})[-/](\d{2})[T ](\d{2}):(\d{2})/);
      if (match) {
        return `${match[1]}-${match[2]}-${match[3]} ${match[4]}:${match[5]}`;
      }

      // Match YYYY-MM-DD
      const dateMatch = strVal.match(/^(\d{4})[-/](\d{2})[-/](\d{2})$/);
      if (dateMatch) {
        return `${dateMatch[1]}-${dateMatch[2]}-${dateMatch[3]}`;
      }

      // Fallback to JS Date parsing
      try {
        const parsedDate = new Date(strVal.replace(/-/g, '/'));
        if (!isNaN(parsedDate.getTime())) {
          const year = parsedDate.getFullYear();
          const month = String(parsedDate.getMonth() + 1).padStart(2, '0');
          const date = String(parsedDate.getDate()).padStart(2, '0');
          const hours = String(parsedDate.getHours()).padStart(2, '0');
          const minutes = String(parsedDate.getMinutes()).padStart(2, '0');
          return `${year}-${month}-${date} ${hours}:${minutes}`;
        }
      } catch (e) {
        console.error('Error parsing date:', e);
      }
      return strVal;
    },
    getFileName(file) {
      return file.fileName || file.name || file.title || '未知文件';
    },
    getFileUrl(file) {
      let url = file.saveName || file.fileUrl || file.url || file.filePath || file.path || '';
      if (url && !url.startsWith('http') && !url.startsWith('/')) {
        url = '/' + url;
      }
      return url;
    },
    getFileExtension(filename) {
      if (!filename) return '';
      const parts = filename.split('.');
      return parts.length > 1 ? parts.pop().toLowerCase() : '';
    },
    getFileIcon(file) {
      const ext = this.getFileExtension(this.getFileName(file));
      if (['pdf'].includes(ext)) return 'el-icon-document';
      if (['doc', 'docx'].includes(ext)) return 'el-icon-document';
      if (['xls', 'xlsx'].includes(ext)) return 'el-icon-data-line';
      if (['jpg', 'jpeg', 'png', 'gif'].includes(ext)) return 'el-icon-picture-outline';
      if (['zip', 'rar', '7z'].includes(ext)) return 'el-icon-collection';
      return 'el-icon-paperclip';
    },
    isPreviewable(file) {
      const ext = this.getFileExtension(this.getFileName(file));
      return ['pdf', 'jpg', 'jpeg', 'png', 'gif'].includes(ext);
    },
    handleFileClick(file) {
      const url = this.getFileUrl(file);
      if (!url) {
        this.$message.warning('附件链接不存在');
        return;
      }
      if (this.isPreviewable(file)) {
        window.open(url, '_blank');
      } else {
        this.downloadFile(file);
      }
    },
    downloadFile(file) {
      const url = this.getFileUrl(file);
      if (!url) {
        this.$message.warning('附件链接不存在');
        return;
      }
      const link = document.createElement('a');
      link.href = url;
      link.target = '_blank';
      link.download = this.getFileName(file);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    getFirstChar(name) {
      if (!name) return '咨';
      return name.charAt(0);
    },
    async fetchPrevNext(infoType) {
      try {
        const res = await getPrevNextSolrAuction(
          infoType, 
          this.assetId, 
          this.keyword, 
          this.assetType, 
          this.sort === 'default' ? '' : this.sort, 
          this.categoryId
        )
        if (res.code === 0 || res.code === 200) {
          this.prevAsset = res.data?.prev ?? null
          this.nextAsset = res.data?.next ?? null
        }
      } catch (error) {
        console.error('获取前后资产信息失败', error)
        this.prevAsset = null
        this.nextAsset = null
      }
    }
  }
}
</script>

<style lang="scss" scoped>
$primary-blue: #1a3a5c;
$primary-red: #c0392b;
$box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05);

.page-banner {
  background-size: cover;
  background-color: $primary-blue;
  color: #fff;
  padding: 60px 0;
  position: relative;
  overflow: hidden;
  width: 100%;

  .banner-single-bg, .banner-slider-bg {
    overflow: hidden;
  }
  
  .banner-single-bg, .banner-slider-bg {
    position: absolute;
    inset: 0;
    z-index: 0;
  }

  .bg-slide {
    position: absolute;
    inset: 0;
    opacity: 0;
    transition: opacity 0.8s ease;
    &.active { opacity: 1; }
  }

  .bg-img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .container {
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 20px;
    position: relative;
    z-index: 2;
  }

  h1 {
    font-size: 24px;
    font-weight: 600;
    margin: 0 0 15px 0;
    letter-spacing: 2px;
  }
  
  ::v-deep .el-breadcrumb__inner,
  ::v-deep .el-breadcrumb__separator {
    color: rgba(255, 255, 255, 0.8) !important;
  }
  ::v-deep .el-breadcrumb__item:last-child .el-breadcrumb__inner {
    color: #fff !important;
  }
}

.asset-detail-section {
    padding: 40px 0;
    background-color: #f8f9fa;
    min-height: 50vh;
}

.detail-container {
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 20px;
}

.asset-detail-layout {
    display: flex;
    gap: 30px;
    align-items: flex-start;
}

.asset-detail-main {
    flex: 1;
    background: #fff;
    border-radius: 8px;
    box-shadow: $box-shadow;
    overflow: hidden;
    padding: 40px;
    overflow-x: hidden;
    word-wrap: break-word;
    word-break: break-word;
    overflow-wrap: break-word;
    width: 100%;
    box-sizing: border-box;
}

.asset-gallery {
    margin-bottom: 30px;
}

.gallery-main {
    position: relative;
    border-radius: 8px;
    overflow: hidden;
    margin-bottom: 15px;
    background: #000;
    height: 400px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.slide-item {
    display: none;
    width: 100%;
    height: 100%;
    &.active { display: block; }
    img { width: 100%; height: 100%; object-fit: contain; }
    .preview-image { width: 100%; height: 100%; display: flex; align-items: center; justify-content: center; }
}

.gallery-prev, .gallery-next {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    background: rgba(0,0,0,0.5);
    color: #fff;
    border: none;
    width: 40px; height: 40px;
    border-radius: 50%;
    cursor: pointer;
    display: flex; align-items: center; justify-content: center;
    transition: background 0.3s;
    font-size: 18px;
    &:hover { background: $primary-red; }
}
.gallery-prev { left: 15px; }
.gallery-next { right: 15px; }

.gallery-counter {
    position: absolute;
    bottom: 15px; right: 15px;
    background: rgba(0,0,0,0.6);
    color: #fff;
    padding: 4px 12px;
    border-radius: 20px;
    font-size: 14px;
}

.gallery-thumbs {
    display: flex;
    gap: 10px;
    overflow-x: auto;
    padding-bottom: 10px;
    scrollbar-width: thin;
    
    .thumb-item {
        width: 100px; height: 75px;
        border-radius: 4px; overflow: hidden;
        cursor: pointer;
        opacity: 0.6;
        transition: all 0.3s;
        border: 2px solid transparent;
        flex-shrink: 0;
        
        &.active, &:hover { opacity: 1; border-color: $primary-red; }
        img { width: 100%; height: 100%; object-fit: cover; }
    }
}

.asset-header {
    margin-bottom: 30px;
    padding-bottom: 20px;
    border-bottom: 1px solid #eee;

    .asset-title {
        font-size: 24px; color: #333; margin: 0 0 15px 0; line-height: 1.4;
    }

    .asset-location {
        color: #666; font-size: 14px; display: flex; align-items: center; gap: 8px;
        i { color: $primary-red; }
        .view-count { margin-left: auto; color: #999; font-size: 14px; }
    }
}

.detail-tabs {
    display: flex; border-bottom: 2px solid #eee; margin-bottom: 25px;
    
    .tab-btn {
        padding: 12px 30px; border: none; background: transparent;
        font-size: 16px; color: #666; cursor: pointer;
        position: relative; transition: all 0.3s;
        
        &::after {
            content: ''; position: absolute; bottom: -2px; left: 0; width: 100%; height: 2px;
            background: $primary-red; transform: scaleX(0); transition: transform 0.3s;
        }
        
        &.active {
            color: $primary-red; font-weight: 500;
            &::after { transform: scaleX(1); }
        }
    }
}

.tab-content {
    display: none;
    &.active { display: block; animation: fadeIn 0.4s ease-out; }
}

.info-section {
    margin-bottom: 30px;

    .info-row {
        display: flex; margin-bottom: 15px; font-size: 14px;
        border-bottom: 1px dashed #ddd;
        padding-bottom: 15px;
        .info-label { width: 100px; color: #666; }
        .info-value {
            flex: 1; color: #333; font-weight: 500;
            &.price { color: $primary-red; font-size: 14px; font-weight: bold; }
            .buy-link { color: $primary-blue; text-decoration: underline; }
        }
    }
    
    h3 { font-size: 16px; margin: 0 0 15px 0; color: #333; border-left: 2px solid #1e3a5f;padding-left: 5px;}
    
    .advantage-content {
        line-height: 1.8; color: #555;
        p { margin-bottom: 10px; }
        .advantage-zcys {
          padding: 15px;
          background: #f8f8f8;
          border-radius: 8px;
          font-size: 14px;
          margin-bottom:15px
        }
    }
}

.disclaimer-content {
    line-height: 2; color: #666; background: #f9f9f9; padding: 20px; border-radius: 8px;
}

.asset-detail-sidebar {
    width: 320px; flex-shrink: 0;

    .contact-card {
        background: #fff; border-radius: 8px; box-shadow: $box-shadow; padding: 30px;
        position: sticky; top: 100px;
    }

    .contact-person {
        text-align: center; margin-bottom: 20px;
        
        .contact-avatar-wrap {
            width: 80px; height: 80px; border-radius: 50%; overflow: hidden;
            margin: 0 auto 15px; border: 3px solid #f0f2f5;
        }
        
        .contact-avatar { width: 100%; height: 100%; object-fit: cover; }
        .contact-avatar-text {
            width: 100%;
            height: 100%;
            background-color: #a2b1ff;
            color: #fff;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 28px;
            font-weight: bold;
        }
        .contact-name { font-size:  14px; font-weight: 600; color: #333; }
    }

    .contact-divider { height: 1px; background: #eee; margin: 20px 0; }

    .contact-item {
        display: flex; align-items: flex-start; gap: 15px; margin-bottom: 15px; color: #666;font-size:14px;
        
        i { color: $primary-red; width: 20px; text-align: center; font-size: 14px; margin-top: 3px; }
        span { flex: 1; line-height: 1.5; word-break: break-all; }
    }
}

.empty-state {
  background: #fff;
  padding: 50px;
  border-radius: 8px;
  box-shadow: 0 2px 12px rgba(0,0,0,0.04);
}

.attachment-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.attachment-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 15px;
  background: #f8f8f8;
  border-radius: 6px;
  transition: all 0.2s;
  
  &:hover {
    background: #f0f4f8;
  }
}

.file-info {
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
  flex: 1;
  overflow: hidden;
  
  i {
    font-size: 18px;
    color: #1a3a5c;
  }
  
  .file-name {
    color: #333;
    font-size: 14px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    transition: color 0.2s;
  }
  
  &:hover .file-name {
    color: #c0392b;
    text-decoration: underline;
  }
}

.article-nav {
  display: flex;
  justify-content: space-between;
  border-top: 1px solid #e8edf3;
  padding-top: 25px;
  margin-top: 40px;
  
  .prev-article, .next-article {
    display: flex;
    flex-direction: column;
    gap: 8px;
    max-width: 48%;
  }
  
  .next-article {
    text-align: right;
    align-items: flex-end;
  }
  
  .nav-label {
    font-size: 0.85rem;
    color: #999;
    display: flex;
    align-items: center;
    gap: 4px;
    margin-bottom: 5px;
  }
  
  .nav-title {
    font-size: 0.95rem;
    color: #333;
    text-decoration: none;
    transition: color 0.2s;
    line-height: 1.4;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    display: block;
    max-width: 100%;
    
    &:hover:not(.empty) {
      color: #b33939;
    }
    
    &.empty {
      color: #bbb;
      cursor: default;
    }
  }
}

@keyframes fadeIn {
    from { opacity: 0; transform: translateY(10px); }
    to { opacity: 1; transform: translateY(0); }
}

/* 防止富文本内容撑破容器 */
::v-deep .tab-content,
::v-deep .info-section {
    width: 100%;
    word-wrap: break-word;
    word-break: break-word;
    overflow-wrap: break-word;
    box-sizing: border-box;
    overflow-x: auto; /* 允许超出时水平滚动 */
}

::v-deep .tab-content img,
::v-deep .info-section img {
    max-width: 100% !important;
    height: auto !important;
}

::v-deep .tab-content *,
::v-deep .info-section * {
    max-width: 100% !important;
    box-sizing: border-box;
    word-wrap: break-word;
    word-break: break-word;
    overflow-wrap: break-word;
}

::v-deep .tab-content table,
::v-deep .info-section table {
    max-width: 100% !important;
    /* display: block; */ /* 移除以恢复表格原生渲染布局，防止出现右侧黑边 */
    /* width: 100% !important; */ /* 移除以避免非 100% 宽度的表格被强行拉伸 */
}

::v-deep .tab-content pre,
::v-deep .info-section pre,
::v-deep .tab-content code,
::v-deep .info-section code {
    white-space: pre-wrap;
    word-wrap: break-word;
    word-break: break-word;
    overflow-wrap: break-word;
}

::v-deep .tab-content a,
::v-deep .info-section a {
    word-break: break-all;
}

/* ===================== iPad 适配 (≤991px) ===================== */
@media (max-width: 991px) {
    .asset-detail-layout {
        flex-direction: column;
    }

    .asset-detail-main {
        padding: 28px;
    }

    .asset-detail-sidebar {
        width: 100%;

        .contact-card {
            position: static;
            display: flex;
            flex-wrap: wrap;
            align-items: center;
            gap: 20px;
            padding: 24px;
        }

        .contact-person {
            display: flex;
            align-items: center;
            gap: 15px;
            margin-bottom: 0;
            text-align: left;

            .contact-avatar-wrap {
                margin: 0;
                width: 60px;
                height: 60px;
                flex-shrink: 0;
            }
        }

        .contact-divider {
            display: none;
        }

        .contact-item {
            margin-bottom: 8px;
        }
    }

    .gallery-main {
        height: 350px;
    }

    .gallery-thumbs .thumb-item {
        width: 80px;
        height: 60px;
    }
}

/* ==================== 手机适配 (≤767px) ==================== */
@media (max-width: 767px) {
    .auction-detail-page {
        overflow-x: hidden;
        width: 100%;
    }

    .page-banner {
        padding: 30px 0;
        h1 { font-size: 1.4rem; letter-spacing: 1px; }
    }

    .asset-detail-section {
        padding: 20px 0;
        overflow-x: hidden;
    }

    .detail-container {
        padding: 0 12px;
        overflow-x: hidden;
    }

    .asset-detail-main {
        padding: 16px;
        border-radius: 6px;
        overflow-x: hidden;
        width: 100%;
    }

    .asset-title {
        word-wrap: break-word;
        word-break: break-word;
        overflow-wrap: break-word;
    }

    /* 图片画廊 */
    .gallery-main {
        height: 220px;
        border-radius: 6px;
    }

    .gallery-prev, .gallery-next {
        width: 32px;
        height: 32px;
        font-size: 14px;
    }
    .gallery-prev { left: 8px; }
    .gallery-next { right: 8px; }

    .gallery-counter {
        padding: 3px 10px;
        font-size: 12px;
        bottom: 10px;
        right: 10px;
    }

    .gallery-thumbs {
        gap: 6px;

        .thumb-item {
            width: 64px;
            height: 48px;
        }
    }

    /* 资产标题 */
    .asset-header {
        margin-bottom: 20px;
        padding-bottom: 15px;

        .asset-title {
            font-size: 18px;
            margin-bottom: 10px;
        }

        .asset-location {
            font-size: 13px;
            flex-wrap: wrap;
            gap: 6px;

            .view-count {
                margin-left: 0;
                width: 100%;
            }
        }
    }

    /* 标签切换 */
    .detail-tabs {
        margin-bottom: 18px;

        .tab-btn {
            padding: 10px 16px;
            font-size: 14px;
        }
    }

    /* 信息行 */
    .info-section {
        margin-bottom: 20px;

        .info-row {
            flex-direction: column;
            gap: 4px;
            padding-bottom: 12px;
            margin-bottom: 12px;

            .info-label {
                width: 100%;
                color: #888;
                font-size: 13px;
            }

            .info-value {
                width: 100%;
                font-size: 14px;
            }
        }

        h3 {
            font-size: 15px;
        }

        .advantage-content {
            font-size: 14px;

            .advantage-zcys {
                padding: 12px;
                font-size: 13px;
            }
        }
    }

    /* 地图 */
    .map-view {
        ::v-deep iframe,
        img {
            height: 220px !important;
        }
    }

    /* 侧边栏联系卡 */
    .asset-detail-sidebar {
        .contact-card {
            flex-direction: column;
            align-items: stretch;
            padding: 20px 16px;
            gap: 12px;
        }

        .contact-person {
            flex-direction: column;
            align-items: center;
            text-align: center;
            gap: 10px;
        }

        .contact-divider {
            display: block;
            margin: 8px 0;
        }

        .contact-item {
            font-size: 13px;
            gap: 10px;
            margin-bottom: 10px;
        }
    }

    /* 空状态 */
    .empty-state {
        padding: 30px 16px;
    }
  .tags {
    span{margin-right: 10px;margin-top: 10px;}
  }

  /* 手机端翻页：改为上下排列，但各自的标签和标题在一行显示 */
  .article-nav {
      flex-direction: column;
      gap: 15px;
      
      .prev-article, .next-article {
          max-width: 100%;
          width: 100%;
          flex-direction: row; /* 水平排列 */
          align-items: center; /* 垂直居中 */
          justify-content: flex-start; /* 全部左对齐 */
          text-align: left; /* 重置PC端的右对齐，确保文本靠左 */
      }
      
      .prev-article > a:first-child, 
      .next-article > a:first-child {
          flex-shrink: 0; /* 防止“上一篇”文本被长标题挤压变形 */
      }

      .nav-label {
          margin-bottom: 0;
      }

      .nav-title {
          white-space: nowrap;     /* 标题单行显示 */
          overflow: hidden;        /* 超出部分隐藏 */
          text-overflow: ellipsis; /* 超出部分显示省略号 */
          flex: 1;                 /* 撑满剩余屏幕宽度 */
          min-width: 0;            /* 关键：修复 flex 布局下文字截断失效的问题 */
      }
  }
}
</style>
